// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"profile-page_pageContainer__3RNqL","headerContainer":"profile-page_headerContainer__1M-7H","headerTitle":"profile-page_headerTitle__3HrNJ"};